/* eslint-disable global-require */

let echoInstance = null
let currentUserId = null

function loadDeps() {
  const Pusher = require('pusher-js')
  const laravelEchoModule = require('laravel-echo')
  const LaravelEcho = laravelEchoModule.default || laravelEchoModule
  return { Pusher, LaravelEcho }
}

function userChannel(userId) {
  return `App.Models.User.${userId}`
}

function isEchoConfigured() {
  return Boolean(process.env.VUE_APP_PUSHER_APP_KEY)
}

function buildEchoOptions() {
  const key = process.env.VUE_APP_PUSHER_APP_KEY
  const cluster = process.env.VUE_APP_PUSHER_APP_CLUSTER || 'mt1'
  const scheme = (process.env.VUE_APP_PUSHER_SCHEME || 'https').toLowerCase()
  const forceTLS = scheme !== 'http'
  const apiBase = process.env.VUE_APP_APIENDPOINT || ''
  const token = localStorage.getItem('accessToken')

  const echoOptions = {
    broadcaster: 'pusher',
    key: key,
    cluster: cluster,
    forceTLS: forceTLS,
    authEndpoint: apiBase + '/broadcasting/auth',
    auth: {
      headers: {
        Authorization: 'Bearer ' + token,
        Accept: 'application/json',
      },
    },
  }

  const wsHost = process.env.VUE_APP_PUSHER_HOST
  if (wsHost) {
    echoOptions.wsHost = wsHost
    echoOptions.wsPort = process.env.VUE_APP_PUSHER_PORT || 6001
    echoOptions.wssPort = process.env.VUE_APP_PUSHER_PORT || 6001
    echoOptions.enabledTransports = ['ws', 'wss']
    echoOptions.disableStats = true
  }

  return echoOptions
}

function initEcho(userId) {
  if (!isEchoConfigured() || !userId) {
    return null
  }

  const token = localStorage.getItem('accessToken')
  if (!token) {
    return null
  }

  if (echoInstance && currentUserId === userId) {
    return echoInstance
  }

  disconnectEcho()

  const deps = loadDeps()
  window.Pusher = deps.Pusher
  if (process.env.NODE_ENV !== 'production') {
    deps.Pusher.logToConsole = true
  }
  echoInstance = new deps.LaravelEcho(buildEchoOptions())
  currentUserId = userId

  return echoInstance
}

function getEcho() {
  return echoInstance
}

function reconnectEcho(userId) {
  return initEcho(userId)
}

function disconnectEcho() {
  if (echoInstance) {
    echoInstance.disconnect()
    echoInstance = null
  }
  currentUserId = null
}

module.exports = {
  userChannel: userChannel,
  isEchoConfigured: isEchoConfigured,
  initEcho: initEcho,
  getEcho: getEcho,
  reconnectEcho: reconnectEcho,
  disconnectEcho: disconnectEcho,
}
